import type {
  TransportType,
  TransportTypeApi,
  TransportTypeFilters,
  TransportTypeFiltersUpdateApi,
  TransportTypes,
  TransportTypesApi,
} from '../../models';
import { inlineSearch, paginate } from '../normalize';

export const normalizeTransportType = (transportType: TransportTypeApi): TransportType => ({
  ...transportType,
  label: transportType.codeDesc,
});

export const normalizeTransportTypes = (response: TransportTypesApi): TransportTypes => {
  const list = (response.items ?? []).sort((a, b) => a.codeDesc.localeCompare(b.codeDesc)).map(normalizeTransportType);
  return {
    list,
    map: list.reduce(
      (acc, transportType) => {
        acc[String(transportType.id)] = transportType;
        return acc;
      },
      {} as TransportTypes['map'],
    ),
  };
};

export const normalizeTransportTypeFilters = (
  filters: Partial<TransportTypeFilters>,
): TransportTypeFiltersUpdateApi => {
  const { search, ...otherFilters } = filters;
  return {
    ...inlineSearch(search),
    ...inlineSearch(otherFilters),
    ...paginate(otherFilters),
    Sorting: 'codeDesc asc',
  };
};
